interface Props {
  className?: string;
}

export const PreviewBanner = ({className}: Props) => {
  return (
    <div className={className}>
      <p className="bg-muted border-b px-4 py-2 text-center text-sm text-muted-foreground">
        You&apos;re viewing a preview of this page
      </p>
    </div>
  );
};
